import type { SupabaseClient } from '@supabase/supabase-js';

export async function signInWithIdentifier(
  client: SupabaseClient,
  apiBase: string,
  identifier: string,
  password: string,
) {
  identifier = identifier.trim();
  if (identifier.includes('@') && !identifier.startsWith('@'))
    return client.auth.signInWithPassword({ email: identifier, password });
  const response = await fetch(`${apiBase}/auth/sign-in`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    cache: 'no-store',
    body: JSON.stringify({ identifier, password }),
  });
  const payload = await response.json();
  if (!response.ok) throw new Error(payload.error?.message ?? 'Unable to sign in. Try again.');
  const session = payload.data?.session;
  if (!session?.access_token || !session?.refresh_token)
    throw new Error('Unable to sign in. Try again.');
  return client.auth.setSession({
    access_token: session.access_token,
    refresh_token: session.refresh_token,
  });
}
